import { DesignSystemColors } from '../../config/designSystem/Colors';
import { ImageBackground } from 'react-native';
import { programImagesFn } from '../../state/stores/Image/ProgramImages';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

export type ProgramBackgroundProps = {
    light: boolean;
    designSystemColor?: DesignSystemColors;
}

export const useProgramBackgroundHeight = () => {
  const {width} = useAvailableDimensions();
  return Math.min(232/330*width,300);
};

export const ProgramBackground = ({light, designSystemColor}: ProgramBackgroundProps) => {
  const HEIGHT = useProgramBackgroundHeight();
  const {width} = useAvailableDimensions();
  return(
    <ImageBackground
      style={{
        width,
        height: HEIGHT,
        position: 'absolute'
      }}
      source={programImagesFn({light , designSystemColor})}
      height={HEIGHT}
      width={width}
      resizeMode='cover'/>
  );

};